import React from "react";
import { connect } from "react-redux";
import SharedSupportTabs from "../../default/components/SupportTabs";
import {
    getTicketList
} from "../../../../../redux/supportticket/supportticketState";
import {
    getPsCategoryList,
    getTicketStatusList,
} from "../../../../../redux/optionlist/optionlistState";

const SupportTabs = (props) => {
    return <SharedSupportTabs variant="partner-service" {...props} />;
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
    categoryData: state.optionlist.psCategoryList?.items,
    ticketStatus: state.optionlist.ticketStatusList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
    getCategory: (data) => dispatch(getPsCategoryList(data)),
    getTicketStatus: (data) => dispatch(getTicketStatusList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportTabs);